// @module Tavanoteam.Calculator.Calculator
define('Calculator.CubicFoot.View'
    , [
        'Calculator.CubicFoot.Form.View'
        , 'calculator_cubic_foot.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        CalculatorCubicFootFormView

        , calculator_cubic_foot_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_cubic_foot_tpl

            , initialize: function (options) {

                this.container = options.container;
                this.isMainPage = options.isMainPage;

                this.layoutComponent = this.container.getComponent('Layout');

                //Initial Shape View
                var shape = 'slope';
                var cubicFootFormView = this.getFormType(shape);
                this.initialView = this.layoutComponent.addChildView('CubicFoot.Form', function () {
                    return cubicFootFormView;
                });

            }

            , events: {
                'click [data-action="change-cubic-foot-view"]': 'getCubicFootView',
                'click [data-action="change-shape-view"]': 'changeShapeView'
            }

            , getCubicFootView: function getCubicFootView(event) {
                var self = this;
                
                this.layoutComponent.removeChildView('CubicFoot.Form', this.initialView);

                var el = this.$(event.target);
                var shape = el.attr("value");

                var cubicFootFormView = this.getFormType(shape);

                var childView = this.layoutComponent.addChildView('CubicFoot.Form', function () {
                    return cubicFootFormView;
                });

                self.render();

                this.layoutComponent.removeChildView('CubicFoot.Form', childView);
            }

            , changeShapeView: function changeShapeView() {

                this.layoutComponent.removeChildView('CubicFoot.Form', this.initialView);

            }

            , getFormType: function getFormType(shape) {

                var self = this;

                if (shape == 'slope') {
                    return new CalculatorCubicFootFormView({isSlope: true});
                }
                else if (shape == 'sphere') {
                    return new CalculatorCubicFootFormView({isSphere: true});
                }
                else if (shape == 'cone') {
                    return new CalculatorCubicFootFormView({isCone: true});
                }
                else if (shape == 'cube') {
                    return new CalculatorCubicFootFormView({isCube: true});
                }
                else if (shape == 'cylinder') {
                    return new CalculatorCubicFootFormView({isCylinder: true});
                }
                else if (shape == 'rectangular') {
                    return new CalculatorCubicFootFormView({isRectangular: true});
                }
                else if (shape == 'capsule') {
                    return new CalculatorCubicFootFormView({isCapsule: true});
                }
                else if (shape == 'spherical') {
                    return new CalculatorCubicFootFormView({isSpherical: true});
                }
                else if (shape == 'conical') {
                    return new CalculatorCubicFootFormView({isConical: true});
                }
                else if (shape == 'ellipsoid') {
                    return new CalculatorCubicFootFormView({isEllipsoid: true});
                }
                else if (shape == 'square') {
                    return new CalculatorCubicFootFormView({isSquare: true});
                }
                else if (shape == 'tube') {
                    return new CalculatorCubicFootFormView({isTube: true});
                }
            
            }

            , getContext: function getContext()
            {

                return {
                    isMainPage : this.isMainPage ? this.isMainPage : false
                }
            }

        });
    });
